import { createContext, useContext } from "react";

const WorkspaceThreadsContext = createContext(null);

/**
 * Provider for sharing workspace threads state across sidebar components.
 * This allows centralized drag-and-drop handling in SidebarDndProvider
 * while keeping the threads state management in one place.
 */
export function WorkspaceThreadsProvider({
  children,
  workspaceThreads,
  setWorkspaceThreads,
  isLoadingThreads,
}) {
  return (
    <WorkspaceThreadsContext.Provider
      value={{ workspaceThreads, setWorkspaceThreads, isLoadingThreads }}
    >
      {children}
    </WorkspaceThreadsContext.Provider>
  );
}

/**
 * Hook to access workspace threads state from context.
 * Returns null if used outside of WorkspaceThreadsProvider.
 */
export function useWorkspaceThreadsContext() {
  return useContext(WorkspaceThreadsContext);
}
